import React, { useState } from 'react';
import './FeedbackModal.css';

const FeedbackModal = ({ interview, onSubmit, onClose, isAdmin = false }) => {
  const [feedback, setFeedback] = useState({
    codingAbility: '',
    algorithmicThinking: '',
    problemSolvingApproach: '',
    timeComplexityAnalysis: '',
    requirementsGathering: '',
    architectureDesign: '',
    scalabilityConsiderations: '',
    tradeoffAnalysis: '',
    situationalAwareness: '',
    leadershipSkills: '',
    teamworkAbility: '',
    conflictResolution: '',
    overallFeedback: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeedback(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(feedback);
  };

  const renderFields = () => {
    if (interview.interviewType === 'DSA') {
      return (
        <>
          <div className="form-group">
            <label>Coding Ability (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="codingAbility"
                value={feedback.codingAbility}
                onChange={handleChange}
                required={interview.interviewType === 'DSA'}
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Algorithmic Thinking (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="algorithmicThinking"
                value={feedback.algorithmicThinking}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Problem Solving Approach (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="problemSolvingApproach"
                value={feedback.problemSolvingApproach}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Time Complexity Analysis (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="timeComplexityAnalysis"
                value={feedback.timeComplexityAnalysis}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
        </>
      );
    } else if (interview.interviewType === 'System Design') {
      return (
        <>
          <div className="form-group">
            <label>Requirements Gathering (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="requirementsGathering"
                value={feedback.requirementsGathering}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Architecture Design (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="architectureDesign"
                value={feedback.architectureDesign}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Scalability Considerations (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="scalabilityConsiderations"
                value={feedback.scalabilityConsiderations}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Tradeoff Analysis (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="tradeoffAnalysis"
                value={feedback.tradeoffAnalysis}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="form-group">
            <label>Situational Awareness (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="situationalAwareness"
                value={feedback.situationalAwareness}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Leadership Skills (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="leadershipSkills"
                value={feedback.leadershipSkills}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Teamwork Ability (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="teamworkAbility"
                value={feedback.teamworkAbility}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
          <div className="form-group">
            <label>Conflict Resolution (1-10)</label>
            <div className="input-group">
              <input 
                type="number" 
                min="1" 
                max="10" 
                name="conflictResolution"
                value={feedback.conflictResolution}
                onChange={handleChange}
                required
                className="form-control"
              />
              <span className="input-addon">/10</span>
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3>Add Feedback for Interview</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <h5>Interview with {interview.candidate?.name || 'Candidate'}</h5>
            <p>Type: {interview.interviewType}</p>
            {renderFields()}
            <div className="form-group">
              <label>Overall Feedback</label>
              <textarea 
                rows={3} 
                name="overallFeedback"
                value={feedback.overallFeedback}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
            {isAdmin && (
              <div className="alert alert-info">
                <small>You are submitting feedback as an admin</small>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="secondary-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="primary-button"
            >
              Submit Feedback
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackModal;
